import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import complete from "../../assets/img/complete.png";
import withAuth from "../../auth/UserRouteAuth";
import nobankPig from "../../assets/img/nobankPig.png";
import "../../css/mobile/MUserPayWaitPg.css";
import React, {useEffect} from "react";
import axios from "../../services/axiosInstance";
import Lottie from "lottie-react";
import loading from "../../assets/motion/fruitLoading.json";


const MUserPayWaitPg = () => {


    const {t} = useTranslation();
    const location = useLocation();
    const data = location.state.data;

    const navigate = useNavigate();

    const orderDetailPgMove = (ordNum) => () => {
        navigate(`/UserMyOrderPg/${ordNum}`);
    };

    useEffect(() => {
        if (data) {
            const clickId = localStorage.getItem('bt_sub1');
            const adChannel = localStorage.getItem('bt_sub2');

            if (clickId && adChannel) {
                let channelType;
                let platformType;

                // ChannelType 추출
                if (adChannel.includes("google")) channelType = '1'
                else if (adChannel.includes("youtube")) channelType = '2'
                else if (adChannel.includes("facebook")) channelType = '3'
                else if (adChannel.includes("instagram")) channelType = '4'
                else if (adChannel.includes("naver")) channelType = '5'
                else if (adChannel.includes("tiktok")) channelType = '6'
                else if (adChannel.includes("threads")) channelType = '7'
                else if (adChannel.includes("twitter")) channelType = '8'
                else if (adChannel.includes("gpt")) channelType = '9'
                else if (adChannel.includes("gemini")) channelType = '10'
                else if (adChannel.includes("community")) channelType = '11'

                // PlatformType 추출(2면 모바일웹 : 웹)
                platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';

                axios({
                    method: 'post',
                    url: '/channelLog/saveAdData',
                    data: {
                        clickId:clickId,
                        eventType: '1', // Purchase
                        channelType: channelType,
                        platformType: platformType,
                        paymentPrice: data.lastPrice
                    },
                }).then((res) => {
                    localStorage.removeItem('bt_sub1');
                    localStorage.removeItem('bt_sub2');
                    console.log("광고수익 기록성공 : ", res.data);
                }).catch((err) => {
                    console.log("광고수익 기록실패 : ", err)
                })
            }
        }
    }, [data]);

    return (
        <div className={'m-a-user-pay-wait-page-container font-t-cont'}>
            <div className={'m-a-user-pay-wait-contents'}>
                <Lottie
                    animationData={loading}
                    loop
                    autoplay
                    className="wd-300 ht-120 opa08"
                    style={{margin:"-20px"}}
                />
                <div className={'m-a-user-pay-wait-title'}>
                    {/*결제신청이 완료되었습니다*/}
                    {data?.payWay === "PM01" ? t('pwHeader4') : t(`pwCont1`)}
                </div>
                <div className={'m-a-user-pay-wait-title-sm'}>
                    {/*원활한 확인을 위해 24시간 내에 입금해주세요*/}
                    {data?.payWay === "PM01" ? t('pwCont3') : t(`pwCont2`)}
                </div>
                <div className={'m-a-user-pay-wait-divider'}/>
                <div className={'m-a-user-pay-wait-row'}>
                    <div className={'m-a-user-pay-wait-label'}>{t(`myTab1`)}</div> {/*주문서*/}
                    <div className={'m-a-user-pay-wait-value font-b'}>{data && data?.orderNumber}</div>
                </div>
                <div className={'m-a-user-pay-wait-row'}>
                    <div className={'m-a-user-pay-wait-label'}>{t(`myTab1`)}</div>
                    <div className={'m-a-user-pay-wait-value'}>
                         {
                                    data && data?.payWay === "PM00" ? t(`modNoBank`) :
                                        data?.payWay === "PM01" ? "Paypal" :
                                            data?.payWay === "PM02" ? "WechatPay" :
                                                data?.payWay === "PM03" ? "AliPay" :
                                                    data?.payWay === "PM04" ? t(`modPt`) :
                                                        data?.payWay === "PM05" ? t(`modDep`) :
                                                            data?.payWay === "PM06" ? "BtoragePay(Global)" :
                                                                data?.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                                    data?.payWay === "PM08" ? "GlobalCard" :
                                                                        data?.payWay === "PM09" ? "KoreanPay" : null
                                }
                    </div>
                </div>
                {data && data?.payWay === "PM00" ?
                    <div className={'m-a-user-pay-wait-row'}>
                        <div className={'m-a-user-pay-wait-label'}>{t(`pwHeader1`)}</div> {/*수령인*/}
                        <div className={'m-a-user-pay-wait-value'}>
                            {t(`pwAcctNm`)}
                        </div>
                    </div>
                    :
                    null
                }
                {data && data?.payWay === "PM00" ?
                    <div className={'m-a-user-pay-wait-row'}>
                        <div className={'m-a-user-pay-wait-label'}>{t(`pwHeader2`)}</div>
                        <div className={'m-a-user-pay-wait-value'}>
                            {t(`pwAcctNum`)}
                        </div>
                    </div>
                    : data?.payWay === "PM02" ?
                        <div className={'m-a-user-pay-wait-row'}>
                            <div className={'m-a-user-pay-wait-label'}>Weixin ID</div>
                            <div className={'m-a-user-pay-wait-value'}>
                                lfamily-help
                            </div>
                        </div>
                        : data?.payWay === "PM03" ?
                            <div className={'m-a-user-pay-wait-row'}>
                                <div className={'m-a-user-pay-wait-label'}>{t(`pwHeader2`)}</div>
                                <div className={'m-a-user-pay-wait-value'}>
                                    13165072023
                                </div>
                            </div>
                            : null
                }
                <div className={'m-a-user-pay-wait-row'}>
                    <div className={'m-a-user-pay-wait-label'}>{t(`pcWon`)}</div> {/*최종원화금액*/}
                    <div className={'m-a-user-pay-wait-value font-b primary'}>
                        &#8361; {data && data?.lastPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                </div>

                {/*payWay가 PM01(페이팔), PM02(위챗), PM03(알리), PM06(비토리지페이)면 출력*/}
                { data && (data?.payWay === "PM01" || data?.payWay === "PM02" ||
                        data?.payWay === "PM03" || data?.payWay === "PM06" || data?.payWay === "PM08") &&
                    <div className="m-a-user-pay-wait-row just-cont-sb">
                        <div className="m-a-user-pay-wait-label">
                            {(data?.payWay === "PM02" || data?.payWay === "PM03") ? t(`pwCny`) : t(`pcFor`)}
                        </div>
                        <div className="font-s-14">
                              <span style={{color: data?.lastForPrice > 0 || data?.payInfoDTO?.lastForPrice > 0 ? 'darkorange' : 'black'}}>
                            {data && (data?.payInfoDTO?.lastForPrice || data?.lastForPrice)}
                            </span>
                            <a className="m-a-user-pay-wait-value pale">&nbsp;{data && (data?.payInfoDTO?.forCurrency || data?.forCurrency)}</a>
                        </div>
                    </div>
                }

            </div>
            <div className={'m-a-user-pay-wait-buttons'}>
                <div className={'m-a-user-pay-wait-button'}
                     onClick={() => navigate("/UserMyPg")}>{t(`hdMypg`)}</div>
                <div className={'m-a-user-pay-wait-button primary'}
                     onClick={orderDetailPgMove(data.orderNumber)}>{t(`modHeader`)}</div>
            </div>
        </div>
    )
}

export default withAuth(MUserPayWaitPg);
